import axios from "axios";

export const GET_ALL_PRODUCTEURS = "GET_ALL_PRODUCTEURS";

export const getAllProducteurs = () => {
  return async (dispatch) => {
    return await axios
      .get(process.env.REACT_APP_SERVER_URL + `/api/user/get/all/producteurs`)
      .then((res) => {
        dispatch({ type: GET_ALL_PRODUCTEURS, payload: res.data });
      })
      .catch((err) => console.log(err));
  };
};
